export const QuestionnaireAnswerDeafultValue = '-';
export const InitialValues = {
    role: QuestionnaireAnswerDeafultValue,
    cancerType: QuestionnaireAnswerDeafultValue,
    cancerSubType: QuestionnaireAnswerDeafultValue,
    state: QuestionnaireAnswerDeafultValue,
    ageGroup: QuestionnaireAnswerDeafultValue,
    gender: QuestionnaireAnswerDeafultValue,
    ethnicity: QuestionnaireAnswerDeafultValue
};
